// @tennis-matches/core/store/schleifchen
// Schleifchen Tournament Store - App-specific instance of generic tournament store

import { createTournamentStore } from '../tournament/createTournamentStore.js';

/**
 * Schleifchen Tournament Store
 * App-specific instance of generic tournament store
 */
export const useSchleifchenStore = createTournamentStore({
  storeName: 'schleifchen',
  defaultTournament: {
    format: 'doubles',
    rounds: 3,
    minutesPerRound: 20,
    courts: { count: 3, numbers: ['1', '2', '3'] },
    points: { win: 2, draw: 1 },
  },
  defaultPlayers: {
    count: 12,
    names: {},
    list: [],
  },
  defaultUI: {
    currentRound: 1,
    completedRound: 0,
    phase: 'idle',
    isSaving: false,
    isGenerating: false,
    error: null,
    scheduleOverviewMode: 'single',
    scheduleOverviewOpenGroup: 'current',
  },
});
